import Config from '../config/config'

export default async function overrideGeo(nick) {
  const payload = { nickname: nick }
  try {
    await fetch(Config.historyService + '/geoupdate', {
      method: 'post',
      body: JSON.stringify(payload),
    })
  } catch (error) {
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/apis/geoOverride.js